//
export const ADD_EVENT_TEXT_LOCAL_CONFIG: any = [
	{
		id: "event_modal_add_event",
		key: "addEvent",
	},
	{
		id: "event_modal_edit_event",
		key: "editEvent",
	},
	{
		id: "event_modal_dashboard",
		key: "dashboard"
	},
	{
		id: "event_modal_dashboard_placeholder",
		key: "dashboardPlaceholder",
	},
	{
		id: "common_date",
		key: "date",
	},
	{
		id: "common_time",
		key: "time",
	},
	{
		id: "event_modal_event_type",
		key: "eventType",
	},
	{
		id: "event_modal_event_type_placeholder",
		key: "eventTypePlaceholder",
	},
	{
		id: "event_modal_title",
		key: "title",
	},
	{
		id: "event_modal_title_placeholder",
		key: "titlePlaceholder",
	},
	{
		id: "event_modal_country",
		key: "country",
	},
	{
		id: "event_modal_platform",
		key: "platform",
	},
	{
		id: "event_modal_all",
		key: "all",
	},
	{
		id: "event_modal_country_global",
		key: "global"
	},
	{
		id: "event_modal_description",
		key: "description",
	},
	{
		id: "event_modal_description_placeholder",
		key: "descriptionPlaceholder",
	},
	{
		id: "event_modal_link",
		key: "link",
	},
	{
		id: "event_modal_link_placeholder",
		key: "linkPlaceholder",
	},
	{
		id: "event_modal_customize_placeholder",
		key: "customizePlaceholder"
	},
	{
		id: "menu_confirm",
		key: "confirm",
	},
	{
		id: "menu_cancel",
		key: "cancel",
	},
	{
		id: "common_overview",
		key: "overview"
	},
	{
		id: "common_realtime",
		key: "realtime"
	},
]

export const ADD_EVENT_FORM_ERROR_CODE = [50001]

export const ADD_EVENT_TIME_OPTIONS = [
	{ value: '00:00:00', text: '00:00' },
	{ value: '01:00:00', text: '01:00' },
	{ value: '02:00:00', text: '02:00' },
	{ value: '03:00:00', text: '03:00' },
	{ value: '04:00:00', text: '04:00' },
	{ value: '05:00:00', text: '05:00' },
	{ value: '06:00:00', text: '06:00' },
	{ value: '07:00:00', text: '07:00' },
	{ value: '08:00:00', text: '08:00' },
	{ value: '09:00:00', text: '09:00' },
	{ value: '10:00:00', text: '10:00' },
	{ value: '11:00:00', text: '11:00' },
	{ value: '12:00:00', text: '12:00' },
	{ value: '13:00:00', text: '13:00' },
	{ value: '14:00:00', text: '14:00' },
	{ value: '15:00:00', text: '15:00' },
	{ value: '16:00:00', text: '16:00' },
	{ value: '17:00:00', text: '17:00' },
	{ value: '18:00:00', text: '18:00' },
	{ value: '19:00:00', text: '19:00' },
	{ value: '20:00:00', text: '20:00' },
	{ value: '21:00:00', text: '21:00' },
	{ value: '22:00:00', text: '22:00' },
	{ value: '23:00:00', text: '23:00' },
	// { value: 'last_moment', text: '23:30以后' },
]


export const tagTypeArr = ['holiday','activity','others','version','opinions','ua']
export const tagColor:any = {
	holiday: {
		background: 'rgba(80, 134, 243, 0.12)',
		fontColor: 'rgba(80, 134, 243, 1)',
	},
	activity: {
		background:  'rgba(119, 224, 151, 0.12)',
		fontColor: 'rgba(119, 224, 151, 1)',
	},
	others: {
		background: 'rgba(110, 119, 148, 0.12)',
		fontColor: 'rgba(110, 119, 148, 1)',
	},
	version: {
		background: 'rgba(241, 158, 85, 0.14)',
		fontColor: 'rgba(241, 158, 85, 1)',
	},
	opinions: {
		background: 'rgba(127, 111, 241, 0.12)',
		fontColor: 'rgba(127, 111, 241, 1)',
	},
	ua: {
		background: 'rgba(94, 200, 241, 0.12)',
		fontColor: 'rgba(94, 200, 241, 1)',
	},


}

export const customTagColor = [
	{
		background: 'rgba(173, 83, 212, 0.12)',
		fontColor: 'rgba(173, 83, 212, 1)',
	},
	{
		background: 'rgba(232, 201, 71, 0.16)',
		fontColor: 'rgba(232, 201, 71, 1)',
	},
	{
		background: 'rgba(72, 142, 137, 0.12)',
		fontColor: 'rgba(72, 142, 137, 1)',
	},
	{
		background: 'rgba(241, 124, 134, 0.12)',
		fontColor: 'rgba(241, 124, 134, 1)',
	},
	{
		background: 'rgba(38, 72, 166, 0.12)',
		fontColor: 'rgba(38, 72, 166, 1)',
	}
]

